import {
  SbbAccentButton as LyneAccentButton,
  SbbButton as LynePrimaryButton,
  SbbSecondaryButton as LyneSecondaryButton,
  SbbTransparentButton as LyneTransparentButton,
} from "@sbb-esta/lyne-react/button";
import { SbbLinkButton as LyneSbbLinkButton } from "@sbb-esta/lyne-react/link";
import classNames from "classnames";
import { useLayout } from "providers";
import React, { PropsWithChildren, SyntheticEvent } from "react";

export type LyneButtonKind = "primary" | "secondary" | "ghost" | "transparent";

interface LyneButtonProps extends PropsWithChildren {
  className?: string;
  disabled?: boolean;
  id?: string;
  title?: string;
  iconName?: string;
  text?: string;
  to?: string;
  value?: string;
  type?: "button" | "submit" | "reset";
  size?: "s" | "m" | "l";
  kind?: LyneButtonKind;
  onClick?: ((event: SyntheticEvent) => void) | undefined;
}

export const LyneButton: React.FC<LyneButtonProps> = ({
  disabled,
  className,
  id,
  title,
  to,
  onClick,
  text,
  value,
  children,
  iconName,
  type = "button",
  kind = "primary",
  size = "s",
}) => {
  const { handleNavClick } = useLayout();

  const childrenToUse = children || text || value;
  className = classNames(className /*, `btn-${kind}-sbb`*/);

  if (!onClick && !!to) {
    return (
      <LyneSbbLinkButton
        type={type}
        className={className}
        title={title}
        id={id}
        onClick={(e) => {
          e.preventDefault();
          handleNavClick(to);
        }}
      >
        {childrenToUse}
      </LyneSbbLinkButton>
    );
  }

  const Component =
    kind === "ghost"
      ? LyneAccentButton
      : kind === "secondary"
        ? LyneSecondaryButton
        : kind === "transparent"
          ? LyneTransparentButton
          : LynePrimaryButton;

  return (
    <Component
      type={type}
      className={className}
      iconName={iconName}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }}
      size={size}
      title={title}
      disabled={disabled}
      id={id}
    >
      {childrenToUse}
    </Component>
  );
};

/*
export const SbbPrimaryButton = (props: SbbButtonProps) => {
  return SbbButton({ ...props, kind: "primary" });
};

export const SbbSecondaryButton = (props: SbbButtonProps) => {
  return SbbButton({ ...props, kind: "secondary" });
};

export const SbbGhostButton = (props: SbbButtonProps) => {
  return SbbButton({ ...props, kind: "ghost" });
};
*/
